import React from "react";
import AgeBySeverityTrend, {
  type AgeBySeverityTrendProps,
} from "../AgeBySeverityTrend/AgeBySeverityTrend";
import { ageBySeverityTrendConfigs } from "../AgeBySeverityTrend/ageBySeverityTrendConfig";

export type AvgAgeBySeverityProps = Omit<
  AgeBySeverityTrendProps,
  "chartConfig"
>;

const AvgAgeBySeverity: React.FC<AvgAgeBySeverityProps> = (props) => {
  return (
    <AgeBySeverityTrend
      {...props}
      chartConfig={ageBySeverityTrendConfigs.avgAgeBySeverity}
    />
  );
};

export default AvgAgeBySeverity;
